import React from 'react';
import { withRouter, Link } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import { getJobProviderCountAction } from '../../actions/home';
import { unreadNotificationListAction } from '../../actions/Notifications';
import ReceivedResumeAnalysis from './Graph/ReceivedResumeAnalysis';
import loadingImage from "../loadingImageRc.gif";

let className = "";
class JobProviderHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestServer: true,
            activeJobsCount: 0,
            resumeCountRecivied: 0,
            unreadNotificationCount: 0,
            latestResumedata: [],
            jobsData: [],
            userData: JSON.parse(localStorage.getItem('userData'))
        };
    }

    componentWillMount() {
        this.props.getJobProviderCountAction();
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.notification && nextProps.notification.statusCode === 200 && nextProps.notification.unReadCount) {
            this.setState({
                unreadNotificationCount: nextProps.notification.unReadCount,
                requestServer: false
            })
        }

        if (nextProps.resumeCount && (nextProps.resumeCount.resume_count || nextProps.resumeCount.jobCount || nextProps.resumeCount.data)) {
            this.setState({
                activeJobsCount: nextProps.resumeCount.jobCount,
                resumeCountRecivied: nextProps.resumeCount.resume_count,
                latestResumedata: nextProps.resumeCount.data,
                requestServer: false
            })
        } else {
            this.setState({
                requestServer: false
            })
        }        

        if (nextProps.jobData && nextProps.jobData.count) {
            this.setState({
                jobsData: nextProps.jobData.data,
                requestServer: false
            })
        } else {
            this.setState({
                requestServer: false
            })
        }
    }

    render() {
        const { requestServer, resumeCountRecivied, activeJobsCount, latestResumedata, jobsData } = this.state;
        
        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        return (
            <div className="home-wrapper">
                <MetaTags>
                    <title>Right Connection</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="MyApp" />
                    <meta property="og:image" content="path/to/image.jpg" />
                </MetaTags>
                <div className={"pageForLoading "+className}>
                   <div className="wrap">
                      <div className="loading">
                            <img src={loadingImage} alt="Loading" />
                      </div>
                    </div> 
                </div>

                <Header props={this.props }/>
                    <div className="body-wrapper bg-image">
                        <div className="container">
                            <div className="row block-section">
                                <div className="col-lg-4 col-md-4 col-sm-4 offset-md-0 resume">
                                    <div className="card card-stats custom-card">
                                        <div className="card-header card-color-a">
                                            <p className="card-category">Recieved Resume</p>
                                            <h3 className="card-title">{resumeCountRecivied}</h3>
                                        </div>
                                        <div className="card-footer card-color-b">
                                            <div className="stats cart-stat">
                                               <Link to={{ pathname: `/account-detail`, redirectFor:"resumeList" }} >more info</Link> 
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col-lg-4 col-md-4 col-sm-4 offset-md-0 resume">
                                    <div className="card card-stats custom-card">
                                        <div className="card-header card-color-a">
                                            <p className="card-category">Active Jobs</p>
                                            <h3 className="card-title">{activeJobsCount}</h3>
                                        </div>
                                        <div className="card-footer card-color-b">
                                            <div className="stats cart-stat">
                                               <Link to={{ pathname: `/account-detail`, redirectFor:"job" }}>more info</Link> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                                <div className="col-lg-4 col-md-4 col-sm-4 offset-md-0 graph-block">
                                        <ReceivedResumeAnalysis/>
                                </div>
                               
                            </div>
                            <div className="row block-section">
                                <div className="col-lg-6 col-md-6 offset-md-0">
                                    <div className="content-block">
                                        <h4 className="news-title">Latest Resume</h4>
                                        <ul className="timeline">
                                        {latestResumedata.map((data,index) => (
                                                <li>
                                                    <a target="_blank" className="linkActive" href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+'/'+data.resumeImage}>{data.userData.firstName}</a>
                                                    <a href="#" className="float-right">{this.props.auth.findTimeDiffrence(data.createdAt)+" ago"}</a>
                                                </li>
                                            ))}
                                           
                                        </ul>
                                    </div>
                                </div>  
                                <div className="col-lg-6 col-md-6 offset-md-0">
                                    <div className="content-block">
                                        <h4 className="news-title">Latest Job Post</h4>
                                        <ul className="timeline">
                                        {jobsData.map((data,index) => (
                                                <li>
                                                    <a target="_blank" className="linkActive" >{data.title}</a>
                                                    <a href="#" className="float-right">{this.props.auth.findTimeDiffrence(data.createdAt)+" ago"}</a>
                                                </li>
                                            ))}
                                           
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        resumeCount: state.home&&state.home.responseCount&&state.home.responseCount.resumeData,
        jobData: state.home&&state.home.responseCount&&state.home.responseCount.jobData,
        notification: state.Notification.response,
    };
}
export default withRouter(connect(mapStateToProps, {
    getJobProviderCountAction,
    unreadNotificationListAction
})(JobProviderHome));


// WEBPACK FOOTER //
// ./src/components/JobProvider/Home.js